import { CustomerTabCreditInfo } from './types';

/**
 * Compare 2 CustomerTabCredits only by amount and payment method for sorting
 *
 * @param CustomerTabCreditA CustomerTabCredit to use for compare
 * @param CustomerTabCreditB CustomerTabCredit to compare againt
 */
export const compareCustomerTabCredits = (
  CustomerTabCreditA: CustomerTabCreditInfo,
  CustomerTabCreditB: CustomerTabCreditInfo,
): -1 | 0 | 1 => {
  const sumCreditAmountA = CustomerTabCreditA.sumCreditAmount;
  const sumCreditAmountB = CustomerTabCreditB.sumCreditAmount;
  if (sumCreditAmountA > sumCreditAmountB) {
    return 1;
  }

  if (sumCreditAmountA < sumCreditAmountB) {
    return -1;
  }

  const sumCreditCountA = CustomerTabCreditA.sumCreditCount;
  const sumCreditCountB = CustomerTabCreditB.sumCreditCount;
  if (sumCreditCountA > sumCreditCountB) {
    return 1;
  }

  if (sumCreditCountA < sumCreditCountB) {
    return -1;
  }

  return 0;
};
